<template>
  <d-container fluid class="main-content-container px-4 pb-4">
    <!-- Error -->
    <div class="error">
      <div class="error__content">
        <h2>{{ $t('errorPage.errorCode') }}</h2>
        <h3>{{ $t('errorPage.pageDoesNotExist') }}</h3>
        <p>{{ $t('errorPage.tryAgainLaterOrContactAdministrator') }}</p>
        <d-button pill @click="goBack">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.back') }}
        </d-button>
      </div>
    </div>
  </d-container>
</template>

<script>
export default {
  name: 'error-404',
  methods: {
    goBack() {
      window.history.back();
    }
  }
}
</script>
